module.exports = __webpack_public_path__ + "static/media/S-task13_adjMatrix.c32867ee.png";